import ScrollToTop from "@common/components/Atoms/ScrollToTop";
import { history } from "@common/utils/history";
import { App } from "@pro/containers/App";
import { ErrorBoundry } from "@pro/error-boundry";
import * as React from "react";
import { Route, Router, Switch } from "react-router";

export const Root: React.SFC = props => {
    return (
        <ErrorBoundry>
            <Router history={history}>
                <ScrollToTop>
                    <Switch>
                        <Route component={App} />
                    </Switch>
                </ScrollToTop>
            </Router>
        </ErrorBoundry>
    );
};
